import * as React from 'react';

interface Props {
}

interface State {
}

class CompleteWithPermanentFail extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = this.getInitialState();
        window.document.title = 'Registration Failed';
    }

    getInitialState = (): State => {
        return {};
    }

    render(): JSX.Element {
        const { } = this.props;
        const { } = this.state;

        return (
            <main>
                <div className="tab-content tabs-style">
                    <div className="tab-pane h-100 fade show active" id="" role="tabpanel">
                        <div className="flex-full">
                            <div className="fix-workspace flex-full">
                                <div className="tab-content wrapper-lv-4">
                                    <div className="tab-pane h-100 fade show active" role="tabpanel">
                                        <div className="row no-gutters pl-1 pr-1 h-100">
                                            <div className="col main-cont">
                                                <div className="flex-full card-sp">
                                                    <div className="card-cont-sp flex-full">
                                                        <div className="fix-workspace">
                                                            <div className="autoscroll-1 content-wrap"> {/* border-cont */}
                                                                <div className="page-title">Welcome to ACscripts</div>
                                                                <div>
                                                                    <p className="col-form-label">Unfortunately there is a problem when verifying your professional credentials or your identity. You have also reached the maximum number of retries per individual.</p>
                                                                    <p className="col-form-label error-text">Error: This user already exists.</p>
                                                                    <p className="col-form-label">Please contact your Vendor administrator to register the new account.</p>
                                                                </div>
                                                                
                                                                <div style={{ textAlign: 'center', fontSize: '10pt' }}>Having questions? Our support team is willing to help.</div>
                                                                <div style={{ textAlign: 'center', fontSize: '10pt' }}>Contact us: <a href="https://www.acscripts.com/help">https://www.acscripts.com/help</a>|<a href="#">support@acscripts.com</a> </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

export default CompleteWithPermanentFail;


// WEBPACK FOOTER //
// ./src/components/General/Error_UserExist.tsx